export default "__VITE_ASSET__Cu1TM2wc__"